import React, { useEffect, useState } from 'react';
import OTPInput from 'react-otp-input';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Button from '../form-components/input/Button';

const ConfirmEmailChange: React.FC = () => {
  const [otp, setOtp] = useState('');
  const [seconds, setSeconds] = useState(180);
  const [status, setStatus] = useState('idle');
  const [otpError, setOtpError] = useState('');
  const authToken = sessionStorage.getItem('token');
  const navigate = useNavigate();

  useEffect(() => {
    if (!authToken) {
      toast.error('Session expired, please log in again.');
      navigate('/login');
      return;
    }

    const interval = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds > 0) {
          return prevSeconds - 1;
        } else {
          clearInterval(interval);
          return 0;
        }
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [authToken, navigate]);

  const handleOtpSubmit = async () => {
    if (!otp) {
      setOtpError('Please enter email verification code');
      return;
    }

    if (otp.length < 6) {
      setOtpError('OTP must be 6 digits');
      return;
    }

    try {
      setStatus('loading');
      const response = await fetch(
        'https://backend-kyw8.onrender.com/confirm-email-change/code',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({ code: otp }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        toast.error('Invalid or expired code', {
          position: 'bottom-right',
        });
        console.log(data);
        setStatus('fail');
      } else {
        toast.success('Email verified successfully', {
          position: 'top-center',
        });
        navigate('/dashboard');
        setStatus('success');
        setOtp('');
        setOtpError('');
      }
    } catch (error) {
      toast.error('Network error, please try again later.', {
        position: 'bottom-right',
      });
      console.log(error);
      setStatus('fail');
    }
  };

  return (
    <div className='main-div'>
      <div className='form-div !max-w-fit w-2/4 flex flex-col gap-6 border border-[#222222] rounded-[20px]'>
        <h2 className='text-black font-semibold text-3xl text-center'>
          Enter Verification Code
        </h2>
        <div>
          <p className='text-[#8b8989] font-normal text-base text-center'>
            We&apos;ve sent an email verification code to your current email address
          </p>
          <p className='text-[#8b8989] font-normal text-base text-center'>
            This code will expire in{' '}
            <span className='text-black'>
              {`00`}:{seconds.toString().padStart(2, '0')}
              {`s`}
            </span>
          </p>
        </div>
        <div>
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={(index) => <span key={`sep-${index}`}>-</span>}
            renderInput={(props, index) => (
              <input
                {...props}
                key={`otp-${index}`}
                className='border border-[#a9a9a9] !w-1/2 md:!w-[80px] !h-[80px] rounded-[8px] focus:border-black'
              />
            )}
          />

          {otpError && <span className='text-[red] text-sm'>{otpError}</span>}
        </div>

        <Button
          isLoading={status === 'loading'}
          disabled={!otp || otp.length < 6 || seconds === 0}
          buttonText='Verify Email'
          onClick={handleOtpSubmit}
        />
      </div>
    </div>
  );
};

export default ConfirmEmailChange;
